// import './index.css';
import { Route, Routes } from 'react-router-dom';
import BookPage from './pages/BookPage';
import Game from './pages/Game';
import Database from './pages/Database';

function App() {
  return (
      <Routes>
        <Route path="/" element={<BookPage />} />
        <Route path="/game" element={<Game />} />
        <Route path="/database" element={<Database />} />
      </Routes>
  );
}

export default App;
